import './styles/homeStyles.css';

const Home = () => {
    return ( 
    <div className="home-wrapper">
        Project Anvaya
    </div> );
}
 
export default Home;